export const environment = {
  production: true,
  // apiurl: "https://rscm-sales-app-api.azurewebsites.net/",
 // apiurl: "https://starr-api.ramarajusurgical.com/",
  //apiurl: "https://starr-api-prd.azurewebsites.net/",
  apiurl: "https://rscm-retail-sales-app-api.azurewebsites.net/",
  checkinDistance: 25,
  googleapimapkey: "AIzaSyCd5FIiqPs-EOzVU5stzYNAIf3PZz5upGE",
  angularurl: "https://rscm-retail-sales-app.azurewebsites.net/",
  logo:"assets/images/Retail_LoginLogo.svg"
};
